
const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-hotel-bed-line',
      title: 'Garden View Rooms',
      description: 'Clean, comfortable accommodations with tropical flair and peaceful garden views',
    },
    {
      icon: 'ri-restaurant-2-line',
      title: 'Sports Pub & Restaurant',
      description: 'Fresh seafood, classic American fare, and late-night bites in a vibrant atmosphere',
    },
    {
      icon: 'ri-music-2-line',
      title: 'Live Entertainment',
      description: 'During Busy season we have Tuesday Jam Night, rotating Live on Sundays and Steak Night Thursdays Year round. ',
    },
    {
      icon: 'ri-swimming-pool-line',
      title: 'Pool & BBQ Area',
      description: 'Beautiful swimming pool with poolside BBQ pit for all guests',
    },
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 font-serif">
            Why Choose The Ocean View
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            A true Keys experience combining comfortable lodging, exceptional dining, and authentic island hospitality
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
